
import {Route,Routes } from 'react-router-dom';
import RegistrationForm from './components/Registration/Register';
import Home from "./Home.jsx"
import AuthPage from './components/Registration/AuthPage.jsx';
import Profile from './components/Profile/GymProfile.jsx';
import GymGallery from './components/Gallery/GymGallery.jsx';

function App() {
  return (
    <div>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/login' element={<AuthPage/>}/>  
          <Route path='/profile' element={<Profile/>}/>  
          <Route path='/gallery' element={<GymGallery/>}/>  
          <Route path='/register' element={<RegistrationForm/>}/>
        </Routes>
      </div>
    );
}

export default App;
